/**
 * Created by enes.kahrovic@thebeaverhead.com on 24/10/2018.
 */

import React from "react";

import { Link } from "react-router-dom";
import PageTemplate from "./../templates/PageTemplate";

const MailchimpInstructionsPage = (props) => {
  return (
    <React.Fragment>
      <PageTemplate
        sidebarId="mailchimp"
        title={"Mailchimp"}
        iconImg={
          <img
            className={"img-responsive img-mailchimp_breadcrumb"}
            alt="Email"
            src={`/img/install_icons/mailchimp.png`}
          />
        }
        headerControls={[
          <Link
            key={"/calendar/new"}
            to="/calendar/new"
            className="btn btn-primary pull-right d-flex align-items-center gap-xxs"
          >
            <i className="material-icons">open_in_new</i> Create new
          </Link>,
        ]}
      >
        <div className={"card-box"}>
          <div className={"card-title"}>
            <h3>Welcome to the Mailchimp Email Template Builder!</h3>
          </div>
          <div className={"row"}>
            <div className={"col-xs-12 col-sm-4 col-md-6"}>
              <div className={"w-100 h-75 m-b-20"}>
                <iframe
                  src="https://player.vimeo.com/video/1025224816?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                  title="Embedding into Wordpress"
                  width={"100%"}
                  height={"100%"}
                ></iframe>
                <script src="https://player.vimeo.com/api/player.js"></script>
              </div>
              <div className={"d-flex gap-xs justify-content-center"}>
                <a
                  href={
                    "http://help.display.church/en/articles/10068292-mailchimp-email-template-alpha"
                  }
                  target={"_mc_instructions"}
                  className={"btn btn-outline-primary"}
                >
                  Full Article & Walkthrough{" "}
                </a>
                <Link to={"/calendars"} className={"btn btn-primary"}>
                  Start: Go to Calendars Page
                </Link>
              </div>
            </div>
            <div className={"col-xs-12 col-sm-8 col-md-6"}>
              <h5>
                Quick Steps to Access the Mailchimp Alpha Testing Email Template
              </h5>
              <ol>
                <li>
                  Create a New Calendar
                  <p>
                    Navigate to calendars and create a new one or select an
                    existing calendar.
                  </p>
                </li>
                <li>
                  Set Up Your Calendar
                  <p>
                    Adjust design and settings, including the number of events
                    to display.
                  </p>
                </li>
                <li>
                  Publish and Install the Template
                  <ol>
                    <li>Click the Install tab.</li>
                    <li>Toggle on the Publish button.</li>
                    <li>Click on the blue Install button</li>
                    <li>Choose the Mailchimp option and click Next.</li>
                  </ol>
                  <p></p>
                </li>
                <li>
                  Select Display Options
                  <ol>
                    <li>Select your template.</li>
                    <li>
                      Choose between Static (one-time events) or Evergreen
                      (recurring events) newsletters.
                    </li>
                    <li>Continue to customize your newsletter.</li>
                  </ol>
                  <p></p>
                </li>
                <li>
                  Click Copy Template and paste the copied HTML into Mailchimp.
                  Adjust titles, dates, colors, and other design elements. Check
                  the email preview and send a test email.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </PageTemplate>
    </React.Fragment>
  );
};

export default MailchimpInstructionsPage;
